"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTPInputComponent = OTPInputComponent;
const react_1 = __importStar(require("react"));
const react_2 = require("react");
const otpInput_styles_1 = require("./otpInput.styles");
const singleInput_1 = __importDefault(require("./singleInput"));
const utils_1 = require("./utils");
function OTPInputComponent(props) {
    const { length, isNumberInput, autoFocus, disabled, onChangeOTP, inputClassName, inputStyle, resetOTP, isError, enableAutoReadOTP, dataTestId } = props, rest = __rest(props, ["length", "isNumberInput", "autoFocus", "disabled", "onChangeOTP", "inputClassName", "inputStyle", "resetOTP", "isError", "enableAutoReadOTP", "dataTestId"]);
    const [activeInput, setActiveInput] = (0, react_1.useState)(0);
    const [otpValues, setOTPValues] = (0, react_1.useState)(Array(length).fill(''));
    (0, react_2.useEffect)(() => {
        if (resetOTP) {
            setOTPValues(Array(length).fill(''));
            setActiveInput(0);
        }
    }, [resetOTP]);
    (0, react_2.useEffect)(() => {
        try {
            enableAutoReadOTP &&
                (0, utils_1.autoReadSMS)(otp => {
                    setOTPValues([...otp]);
                    onChangeOTP(otp);
                });
        }
        catch (_a) { }
    }, []);
    // Helper to return OTP from inputs
    const handleOtpChange = (0, react_1.useCallback)((otp) => {
        const otpValue = otp.join('');
        onChangeOTP(otpValue);
    }, [onChangeOTP]);
    // Helper to return value with the right type: 'text' or 'number'
    const getRightValue = (0, react_1.useCallback)((str) => {
        let changedValue = str;
        if (!isNumberInput) {
            return changedValue;
        }
        return !changedValue || /\d/.test(changedValue) ? changedValue : '';
    }, [isNumberInput]);
    // Change OTP value at focussing input
    const changeCodeAtFocus = (0, react_1.useCallback)((str) => {
        const updatedOTPValues = [...otpValues];
        updatedOTPValues[activeInput] = str[0] || '';
        setOTPValues(updatedOTPValues);
        handleOtpChange(updatedOTPValues);
    }, [activeInput, handleOtpChange, otpValues]);
    // Focus `inputIndex` input
    const focusInput = (0, react_1.useCallback)((inputIndex) => {
        const selectedIndex = Math.max(Math.min(length - 1, inputIndex), 0);
        setActiveInput(selectedIndex);
    }, [length]);
    const focusPrevInput = (0, react_1.useCallback)(() => {
        focusInput(activeInput - 1);
    }, [activeInput, focusInput]);
    const focusNextInput = (0, react_1.useCallback)(() => {
        focusInput(activeInput + 1);
    }, [activeInput, focusInput]);
    // Handle onFocus input
    const handleOnFocus = (0, react_1.useCallback)((index) => () => {
        focusInput(index);
    }, [focusInput]);
    // Handle onChange value for each input
    const handleOnChange = (0, react_1.useCallback)((e) => {
        var _a;
        if (((_a = e.currentTarget.value) === null || _a === void 0 ? void 0 : _a.length) > 1) {
            var dataTransfer = new DataTransfer();
            dataTransfer.setData('text/plain', e.currentTarget.value);
            handleOnPaste(new ClipboardEvent('paste', { clipboardData: dataTransfer }));
        }
        else {
            const val = getRightValue(e.currentTarget.value);
            if (!val) {
                e.preventDefault();
                return;
            }
            changeCodeAtFocus(val);
            focusNextInput();
        }
    }, [changeCodeAtFocus, focusNextInput, getRightValue]);
    // Hanlde onBlur input
    const onBlur = (0, react_1.useCallback)(() => {
        setActiveInput(-1);
    }, []);
    // Handle onKeyDown input
    const handleOnKeyDown = (0, react_1.useCallback)((e) => {
        switch (e.key) {
            case 'Backspace':
            case 'Delete': {
                e.preventDefault();
                if (otpValues[activeInput]) {
                    changeCodeAtFocus('');
                }
                else {
                    focusPrevInput();
                }
                break;
            }
            case 'ArrowLeft': {
                e.preventDefault();
                focusPrevInput();
                break;
            }
            case 'ArrowRight': {
                e.preventDefault();
                focusNextInput();
                break;
            }
            case ' ': {
                e.preventDefault();
                break;
            }
            default:
                break;
        }
    }, [activeInput, changeCodeAtFocus, focusNextInput, focusPrevInput, otpValues]);
    const handleOnPaste = (0, react_1.useCallback)((e) => {
        e.preventDefault();
        const pastedData = e.clipboardData
            .getData('text/plain')
            .trim()
            .slice(0, length - activeInput)
            .split('');
        if (pastedData) {
            let nextFocusIndex = 0;
            const updatedOTPValues = [...otpValues];
            updatedOTPValues.forEach((val, index) => {
                if (index >= activeInput) {
                    const changedValue = getRightValue(pastedData.shift() || val);
                    if (changedValue) {
                        updatedOTPValues[index] = changedValue;
                        nextFocusIndex = index;
                    }
                }
            });
            setOTPValues(updatedOTPValues);
            setActiveInput(Math.min(nextFocusIndex + 1, length - 1));
            handleOtpChange(updatedOTPValues);
        }
    }, [activeInput, getRightValue, length, otpValues, handleOtpChange]);
    return (react_1.default.createElement(otpInput_styles_1.OTPContainer, Object.assign({}, rest), Array(length)
        .fill('')
        .map((_, index) => (react_1.default.createElement(singleInput_1.default, { key: index, focus: activeInput === index, value: otpValues && otpValues[index], autoFocus: autoFocus, onFocus: handleOnFocus(index), onChange: handleOnChange, onKeyDown: handleOnKeyDown, onBlur: onBlur, onPaste: handleOnPaste, style: inputStyle, disabled: disabled, isWide: false, index: index, dataTestId: dataTestId })))));
}
exports.default = OTPInputComponent;
//# sourceMappingURL=otpMain.js.map